// extracted by mini-css-extract-plugin
export default {"base":"ReleaseStageTabs__base-i0ZYf","tabsContainer":"ReleaseStageTabs__tabsContainer-lSr2f","activeStage":"ReleaseStageTabs__activeStage-sv0Gw"};